import React, {useEffect} from 'react';
import Rewards from "Components/Rewards";

export default function RewardsPage() {
    useEffect(() => {
        window.dispatchEvent(new CustomEvent("resize"));
    }, []);

    return (
        <Rewards/>
    );
}
